import { IDatiqMapStyleConfiguration } from './datiq-map.interface';
import { defaultDatiqMapStyleConfiguration } from './datiq-map-model-defaults';

// Current key is for the test environment
export const DEFAULT_API_KEY: string =
    'AIzaSyDB3XrQ9ZVmKy5fR6h63s6TkIfoE1z8aLI';

export class DatiqMapStyleConfiguration {
    private _configuration: IDatiqMapStyleConfiguration;

    constructor() {
        this._configuration = { ...defaultDatiqMapStyleConfiguration };
    }

    setFillColor(fillColor: string): this {
        this._configuration = !!fillColor
            ? { ...this._configuration, fillColor }
            : { ...this._configuration };

        return this;
    }

    setStrokeColor(strokeColor: string): this {
        this._configuration = !!strokeColor
            ? { ...this._configuration, strokeColor }
            : { ...this._configuration };

        return this;
    }
    setStrokeWeight(strokeWeight: number): this {
        this._configuration = !!strokeWeight
            ? { ...this._configuration, strokeWeight }
            : { ...this._configuration };

        return this;
    }

    setFillOpacity(fillOpacity: number): this {
        this._configuration = !!fillOpacity
            ? { ...this._configuration, fillOpacity }
            : { ...this._configuration };

        return this;
    }

    setZIndex(zIndex: number): this {
        this._configuration = !!zIndex
            ? { ...this._configuration, zIndex }
            : { ...this._configuration };

        return this;
    }

    setClickable(clickable: boolean): this {
        this._configuration =
            clickable !== undefined
                ? { ...this._configuration, clickable }
                : { ...this._configuration };

        return this;
    }

    build(): IDatiqMapStyleConfiguration {
        return { ...this._configuration };
    }
}
